import { Moment } from 'moment'

import { DefaultFile } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces'

export enum DocumentStatus {
	Pending = 'Pending',
	Active = 'Active',
	Rejected = 'Rejected',
	Inactive = 'Inactive'
}

export enum DocumentFilterFields {
	supplierLocationId = 'supplierLocationId',
	documentTypeIds = 'documentTypeIds',
	statusId = 'statusId',
	showOnlySupplierDocuments = 'showOnlySupplierDocuments'
}

export declare namespace Document {
	interface Basic {
		id: number
		documentName: BasicString
		documentType: Nullable<Entity>
		documentStatus: BasicString
		expirationDate: BasicString
		lastUpdatedBy: BasicString
		lastUpdateDate: BasicString
		comment: BasicString
		supplier: Nullable<Entity>
		supplierLocation: Nullable<Entity>
	}

	interface Detailed extends Exclude<Basic, 'supplier' | 'supplierLocation'> {}

	interface Type extends Entity {
		isForSupplier: boolean
	}

	namespace Generic {
		interface Form {
			documentTypeId: LabelValue<number> | null
			expirationDate: Moment | null
			supplierId: LabelValue<number> | null
			supplierLocationId: LabelValue<number> | null
			file: DefaultFile | null
		}
		interface Request {
			documentTypeId: number
			expirationDate: BasicString
			file: File | null
		}
	}
	namespace Filter {
		interface Config {
			[DocumentFilterFields.documentTypeIds]: ConfigFilterItem<string, string[]>
			[DocumentFilterFields.supplierLocationId]: ConfigFilterItem<string, string>
			[DocumentFilterFields.statusId]: ConfigFilterItem<string, string>
			[DocumentFilterFields.showOnlySupplierDocuments]: ConfigFilterItem<string, boolean>
		}
	}
}
